export default {
  PAGE: 1,
  LIMIT: 20
}



// WEBPACK FOOTER //
// ./src/constants/common.js